export default __webpack_public_path__ + "static/media/Crane.b038cc28.svg";